export const ZIXI_LOCATION = {
  EAST: 'east',
  WEST: 'west'
};

export const ZIXI_LOCATIONS = [ZIXI_LOCATION.EAST, ZIXI_LOCATION.WEST];
